<template>
    <div class="today-alarm" >
        <div class="middletitleleft dn-title-bg">
            <span>{{factorTitle}}</span>
        </div>
        <div class="middleleft dn-content-bg" v-loading="ifLoad">
            <div class="guanBox">
                <Guan :pieData="pieData" :factorTitle="factorTitle"></Guan>
            </div>
        </div>
    </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
import Guan from "./echart/Guan.vue";
export default {
    props: {
        factorData:{
            type:Array,
            default:()=>[],
        },
        ifLoad:{
            type:Boolean,
            default:false,
        },
        factorTitle:{
            type:String,
            default:'标题',
        },
    },
    data() {
        return {
            pieData:[]
        }
    },
    created() {
    },
    methods: {
        //改表头颜色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
            return 'background-color: #F3F3F3;color: #666;'
        }
        },
    },
    watch: {
        factorData: {
            handler(newVal, oldVal) {
                let vm = this
                console.log(newVal)
                vm.pieData=newVal
            },
            deep: true
        }
    },
    components:{
        Guan
    }
}
</script>
<style lang="scss" scoped>
.today-alarm{
    display: flex;
    flex: 1;
    flex-flow: column;
}
.middletitleleft {
//   background: #0197EE;
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.middleleft {
//   background: #fff;
  flex:1;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.guanBox {
  width: 100%;
  height: 100%;
}
</style>